import { useTranslation } from "react-i18next";
import { trackLanguageChange } from "../sidebarAnalytics";
import { menuIcon } from "./menuStyles";

interface LanguageToggleProps {
  isDarkMode: boolean;
}

// Selector ES | EN: se ve de un vistazo cuál está activo. Antes eran dos etiquetas
// con un interruptor verde en medio, y no quedaba claro si el verde era «español».
export function LanguageToggle({ isDarkMode }: LanguageToggleProps) {
  const { t, i18n } = useTranslation("common");
  const current = i18n.language?.startsWith("en") ? "en" : "es";

  const select = (lang: "es" | "en") => {
    if (lang === current) return;
    trackLanguageChange(current, lang);
    i18n.changeLanguage(lang);
  };

  return (
    <div className={`w-full h-9 px-2.5 flex items-center gap-2.5 text-[14px] ${isDarkMode ? "text-gray-200" : "text-gray-700"}`}>
      <i className={`ri-translate-2 ${menuIcon(isDarkMode)}`} aria-hidden />
      <span>{t("language.label")}</span>
      <div
        role="radiogroup"
        aria-label={t("language.label")}
        className={`ml-auto flex p-0.5 rounded-lg text-xs font-medium ${isDarkMode ? "bg-white/[0.06]" : "bg-black/[0.05]"}`}
      >
        {(["es", "en"] as const).map((lang) => (
          <button
            key={lang}
            type="button"
            role="radio"
            aria-checked={current === lang}
            onClick={() => select(lang)}
            className={`px-2 h-6 rounded-md transition-colors duration-150 ${
              current === lang
                ? isDarkMode
                  ? "bg-white/15 text-white"
                  : "bg-white text-gray-900 shadow-sm"
                : isDarkMode
                  ? "text-gray-400 hover:text-gray-200"
                  : "text-gray-500 hover:text-gray-800"
            }`}
          >
            {lang.toUpperCase()}
          </button>
        ))}
      </div>
    </div>
  );
}
